const ChevronDownZip = ({ ...props }) => {
  return (
    <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15.586 3.707 7.293 2.293 8.707l9 9a1 1 0 0 0 1.414 0l9-9-1.414-1.414L12 15.586Z"
      fill="#1B1323"
    />
  </svg>
  )
}

export default ChevronDownZip
